import { uuid } from 'drizzle-orm/pg-core';
import { user } from '../auth.js';
export function userActions() {
    return {
        // AnyPgColumn is needed to be able to define these columns in the "user" table, otherwise it would lead to type errors
        createdBy: uuid('created_by').references(() => user.id),
        updatedBy: uuid('updated_by').references(() => user.id),
        deletedBy: uuid('deleted_by').references(() => user.id),
    };
}
//# sourceMappingURL=user-actions.js.map